"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.moduleContentClickEvent = exports.featuredCarouselSlideClickEvent = exports.featuredCarouselSlideViewEvent = exports.readingListClickEvent = exports.tagClickEvent = exports.sectionViewEvent = void 0;
var _1 = require(".");
var sectionViewEvent = function (type, position) {
    (0, _1.sendEvent)("home", "section", null, "view", {
        type: type,
        position: position,
    });
};
exports.sectionViewEvent = sectionViewEvent;
var tagClickEvent = function (tag) {
    (0, _1.sendEvent)(null, null, null, "app_page_view_v1", {
        page: {
            tag: { tags: [tag] },
        },
        source: {
            home: {},
        },
    });
};
exports.tagClickEvent = tagClickEvent;
var readingListClickEvent = function (readingListId) {
    (0, _1.sendEvent)(null, null, null, "app_page_view_v1", {
        page: {
            reading_list: {
                reading_list_id: readingListId,
            },
        },
        source: {
            home: {},
        },
    });
};
exports.readingListClickEvent = readingListClickEvent;
var featuredCarouselSlideViewEvent = function (itemId, offset) {
    (0, _1.sendEvent)("home", "featured", null, "view", {
        itemid: itemId,
        offset: offset,
    });
};
exports.featuredCarouselSlideViewEvent = featuredCarouselSlideViewEvent;
var featuredCarouselSlideClickEvent = function (itemId, offset) {
    (0, _1.sendEvent)("home", "featured", null, "click", {
        itemid: itemId,
        offset: offset,
    });
};
exports.featuredCarouselSlideClickEvent = featuredCarouselSlideClickEvent;
var moduleContentClickEvent = function (moduleType, contentType, contentIds, algoSource) {
    (0, _1.sendEvent)("home", "module", "content", "click", {
        module_type: moduleType,
        content_type: contentType,
        contentids: contentIds,
        algo_source: algoSource,
    });
};
exports.moduleContentClickEvent = moduleContentClickEvent;
